import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { OrderService } from "../../../services/order-service";
import { DataGrid } from "@material-ui/data-grid";
import { Modal } from "react-bootstrap";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import TablePagination from "@material-ui/core/TablePagination";
import { useParams } from "react-router-dom";
import AuthContext from "../../../context/auth-context";
import moment from "moment";

export const Shippedorder = ({setShippedOrderCount}) => {
  const ctx = useContext(AuthContext);

  const { customerID } = useParams();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [orders, setOrderDetails] = useState([]);

  const [orderID, setorderID] = useState();

  const statusname = "DELIVERING";

  const history = useHistory();

  const [state, setState] = useState(false);

  const [submitloading, setSubmitLoading] = useState(true);

  const handleShow4 = (e) => {
    setState({ show4: true });
    setorderID(e);
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const orderSearch = async () => {
    try {
      const result = await OrderService.userOrderDetails(
        statusname,
        customerID,
        rowsPerPage,
        page
      );

      setOrderDetails(result.results);
      setDataCount(result.pagination.total);

      //Update parent count
      if (result.pagination.total) {
        setShippedOrderCount(result.pagination.total);
      }
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  useEffect(() => {
    orderSearch();
  }, [statusname, rowsPerPage, page, count]);

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await OrderService.orderDelete(orderID);

      setSubmitLoading(true);
      notify("Order successfully deleted");
      handleClose();
      orderSearch();
    } catch (err) {
      notifyWarning(err.response.data.message);
      setSubmitLoading(true);
      //show error toast
    }
  };

  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const columns = [
    {
      field: "id",
      headerName: "Order Id",
      flex: 4,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>#{params.row.id} - {params.row.user.name} </div>;
      },
    },
    {
      field: "total",
      headerName: "Price(Rs.)",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "payment_method",
      headerName: "Payment Method",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.payment_method === "CASH_ON_DELIVERY") {
          return (
            <div>
              {" "}
              <span>COD</span>
            </div>
          );
        } else if(params.row.payment_method === "PAYHERE") {
          return (
            <div>
              {" "}
              <span>PH</span>
            </div>
          );
        }else{
          return (
            <div>
              {" "}
              <span>BD</span>
            </div>
          );
        }
      }
    },
    {
      field: "payment_status",
      headerName: "Payment Status",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.payment_status === "PENDING") {
          return (
            <div>
              {" "}
              <span className="badge badge-warning">PENDING</span>
            </div>
          );
        } else if (params.row.payment_status === "APPROVED") {
          return (
            <div>
              {" "}
              <span className="badge badge-success">APPROVED</span>
            </div>
          );
        } else if (params.row.payment_status === "CANCELED") {
          return (
            <div>
              <span className="badge badge-danger">CANCELED</span>
            </div>
          );
        } else if (params.row.payment_status === "FAILED") {
          return (
            <div>
              <span className="badge badge-primary">FAILED</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="badge badge-dark">CHANGEBACK</span>
            </div>
          );
        }
      },
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 2,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.status === statusname) {
          return (
            <div>
              <span className="badge badge-secondary">{params.row.status === statusname ? 'SHIPPED' : ''}</span>
            </div>
          );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              history.push(`/edit-order/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    // {
    //   field: "delete",
    //   headerName: "Delete",
    //   sortable: false,
    //   flex: 1,
    //   disableClickEventBubbling: true,
    //   renderCell: (params) => {
    //     return (
    //       <div>
    //         <i
    //           className="far fa-trash-alt ms-text-danger"
    //           onClick={() => {
    //             handleShow4(params.row.id);
    //           }}
    //           style={{ cursor: "pointer" }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-xl-12">
              <div className="ms-panel">
                <div className="ms-panel-header">
                  <div className="row">
                    <div className="col-md-11">
                      <h6>Shipped Order List </h6>
                    </div>
                    <div>
                      <Modal
                        show={state.show4}
                        onHide={handleClose}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                      >
                        <Modal.Header>
                          <h3 className="modal-title has-icon ms-icon-round ">
                            Confirm Deletion
                          </h3>
                          <button
                            type="button"
                            className="close"
                            onClick={handleClose}
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                        </Modal.Header>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "2vh",
                          }}
                        >
                          <h6 style={{ color: "red" }}>
                            Are you sure you want to remove this item ?
                          </h6>
                        </div>
                        <Modal.Footer>
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-primary shadow-none"
                            style={{ backgroundColor: "red" }}
                            onClick={onDelete}
                          >
                            Delete
                          </button>

                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                          >
                            Cancel
                          </button>
                        </Modal.Footer>
                      </Modal>
                    </div>
                  </div>
                </div>
                <div className="ms-panel-body">
                  <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                    <DataGrid
                      rows={orders}
                      disableExtendRowFullWidth={false}
                      columns={columns}
                      pageSize={rowsPerPage}
                      pagination
                      autoHeight
                      hideFooter
                    />
                    <TablePagination
                      component="div"
                      count={count}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shippedorder;
